import { defineStore } from 'pinia'

import api from '@/api/member.js'

export const useMemberStore = defineStore('member', {
  state: () => ({
    company: {},
    profile: { init: true },
    bankInformation: {},
    isAuthLoading: false
  }),
  actions: {
    async getCompany ({ fail }) {
      return api.getCompany().then((res) => {
        this.company = res.body.data
      }).catch(res => fail && fail(res))
    },
    async getProfile () {
      this.profile = { init: true }
      return api.getProfile()
        .then((res) => {
          this.profile = res.body
        }).catch(err => {
          if (err.code === 403) {
            this.profile = {
              forbidden: true
            }
          } else {
            this.profile = {}
          }
          return err
        })
    },
    async getBankInformation ({ success, fail }) {
      return api.getBankInformation()
        .then((res) => {
          this.bankInformation = res.body.data
          success(res.body.data)
        })
        .catch((err) => fail && fail(err))
    },
    setAuthLoading (v) {
      this.isAuthLoading = v
    }
  }
})
